
import React from 'react';
import { useModalActions } from '../../Modals/modalActions';
import { ModalMenuUI } from '@cube3/ui/src/Modal/ModalMenuUI';
import { CommentFieldSmart } from './ReviewPanel';
import { ReviewCommentsFilterProvider } from '../Context/reviewCommentsFilterContext';
import { ReviewViewContext } from '../Context/reviewViewContext';
import { Asset } from '@cube3/common/model/schema/resources/asset';
import { Reviewlink } from '@cube3/common/model/resource-types';
import { ReviewAssetViewerContext, ReviewToolContext } from '../Context/reviewToolContext';
import { WorkspaceFeaturesProvider } from '@cube3/state/src/redux/components/Hooks/useFeatures';
import { MediaPlayer } from '@cube3/ui/src/previews/VideoPreview/MediaPlayer';
import { isMobile } from 'react-device-detect';


interface ReviewLink_AddCommentModalProps {
    modalContext: {
        reviewLink: Reviewlink;
        activeAsset: Asset;
        email: string;
        userImage?: string;
        //
        setDrawnSvg: (svg) => void;
        drawnSvg: string;
        toggleDrawingBar: (toggle?: boolean) => void;
        drawingBarToggled: boolean;
        activeTemplate: string;
        playing: boolean;
        player: MediaPlayer;
        timestamp: number;
    }
}

export const ReviewLink_AddCommentModal = (props: ReviewLink_AddCommentModalProps) => {
    const { modalContext } = props;

    const { reviewLink,
        activeAsset,
        email,
        userImage,
        //
        setDrawnSvg,
        drawnSvg,
        toggleDrawingBar,
        drawingBarToggled,
        playing,
        activeTemplate,
        player,
        timestamp = 0
    } = modalContext;


    const { previousModal, openModal } = useModalActions();

    const handleOnPost = () => {
        previousModal();
        openModal('reviewlink_savedComment');
    }


    return (
        <ModalMenuUI
            title={isMobile ? '' : 'Post Comment:'}
            autoHeight
            onCloseEvent={previousModal}
        >
            <div style={{ marginTop: 20 }}>
                <WorkspaceFeaturesProvider>
                    <ReviewViewContext.Provider value={{ reviewLink, activeAsset, email, userImage }}>

                        <ReviewToolContext.Provider
                            value={{
                                drawnSvg,
                                drawingBarToggled,
                                player,
                                playing,
                                activeTemplate,
                                setDrawnSvg,
                                toggleDrawingBar
                            }}
                        >
                            <ReviewAssetViewerContext.Provider value={{ timestamp }}>
                                <ReviewCommentsFilterProvider>
                                    <CommentFieldSmart onMobileDraw={previousModal} onCancel={previousModal} onPost={handleOnPost} isModal={true} />
                                </ReviewCommentsFilterProvider>
                            </ReviewAssetViewerContext.Provider>
                        </ReviewToolContext.Provider>
                    </ReviewViewContext.Provider>
                </WorkspaceFeaturesProvider>

            </div>
        </ModalMenuUI>
    );
};
